import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./NIISensitivityModelerGlobal.styles";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import { TreasuryKRISummaryProvider } from "../../../context/TreasuryKRISummaryContext";
import { ApprovalProvider } from "../../../context/ApprovalContext";
import NIISensitivityModelerGlobalFilters from "./NIISensitivityModelerGlobalFilters.component";
import NIISensitivityModelerGlobalReports from "./NIISensitivityModelerGlobalReports.component";
import { Card } from "antd";
import AdvancedNIISensitivityModelerGlobalReports from "./AdvancedNIISensitivityModelerGlobalReports.component";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const INITIAL_PANEL_STATE = {
  isAdvancedNII: false,
  appliedFilters: null,
  isWritableSfc: false,
};

const NIISensitivityModelerGlobal = ({ toCompare = false } = {}) => {
  const { classes } = useStyles(toCompare);

  const [singleState, setSingleState] = useState(INITIAL_PANEL_STATE);

  const [compareState, setCompareState] = useState({
    left: INITIAL_PANEL_STATE,
    right: INITIAL_PANEL_STATE,
  });

  const handleSubmitSingle = (filters) => {
    setSingleState((prev) => ({
      ...prev,
      appliedFilters: { ...filters },
    }));
  };

  const setSingleIsAdvancedNII = (value) => {
    setSingleState((prev) => ({
      ...prev,
      isAdvancedNII: value,
    }));
  };

  const setSingleIsWritableSfc = (value) => {
    setSingleState((prev) => ({
      ...prev,
      isWritableSfc: value,
    }));
  };

  const handleSubmitForSide = (side) => (filters) => {
    setCompareState((prev) => ({
      ...prev,
      [side]: {
        ...prev[side],
        appliedFilters: { ...filters },
      },
    }));
  };

  const setIsAdvancedNIIForSide = (side) => (value) => {
    setCompareState((prev) => ({
      ...prev,
      [side]: {
        ...prev[side],
        isAdvancedNII: value,
      },
    }));
  };

  const setIsWritableSfcForSide = (side) => (value) => {
    setCompareState((prev) => ({
      ...prev,
      [side]: {
        ...prev[side],
        isWritableSfc: value,
      },
    }));
  };

  const renderPanel = ({ side = null, toSave = false }) => {
    const panelState = toCompare ? compareState[side] : singleState;

    const filterProps = toCompare
      ? {
          toCompare,
          setIsAdvancedNII: setIsAdvancedNIIForSide(side),
          isAdvancedNII: panelState.isAdvancedNII,
          setIsWritableSfc: setIsWritableSfcForSide(side),
          handleSubmit: handleSubmitForSide(side),
        }
      : {
          toCompare,
          setIsAdvancedNII: setSingleIsAdvancedNII,
          isAdvancedNII: singleState.isAdvancedNII,
          setIsWritableSfc: setSingleIsWritableSfc,
          handleSubmit: handleSubmitSingle,
        };

    return (
      <HedgeRatioProvider>
        <TreasuryKRISummaryProvider>
          <ApprovalProvider>
            <Card
              className={classes.NIISensitivityModelerGlobalCardResponsive}
              style={{
                padding: "6px",
                marginBottom: "20px",
              }}
            >
              {(!toCompare || side) && (
                <NIISensitivityModelerGlobalFilters {...filterProps} />
              )}

              {panelState.appliedFilters && !panelState.isAdvancedNII && (
                <NIISensitivityModelerGlobalReports
                  toSave={toSave}
                  toCompare={toCompare}
                  isWritableSfc={panelState.isWritableSfc}
                  appliedFilters={panelState.appliedFilters}
                />
              )}

              {panelState.appliedFilters && panelState.isAdvancedNII && (
                <AdvancedNIISensitivityModelerGlobalReports
                  toSave={toSave}
                  toCompare={toCompare}
                  isWritableSfc={panelState.isWritableSfc}
                  appliedFilters={panelState.appliedFilters}
                />
              )}
            </Card>
          </ApprovalProvider>
        </TreasuryKRISummaryProvider>
      </HedgeRatioProvider>
    );
  };

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        {!toCompare && renderPanel({ toSave: true })}

        {toCompare && (
          <>
            {renderPanel({ side: "left", toSave: true })}
            {renderPanel({ side: "right", toSave: false })}
          </>
        )}

        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default NIISensitivityModelerGlobal;
